export default "__VITE_ASSET__lL6x0PgP__"